import { parse } from 'node-html-parser'
import type { HTMLElement } from 'node-html-parser'

export const parseHtml = (html: string): HTMLElement => parse(html)

export const stringifyHtml = (html: HTMLElement): string => html.toString()
